module.exports = __webpack_public_path__ + "images/emoji/wedding.8d05387bdef09f761fd1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/wedding.png
// module id = 8P3Q
// module chunks = 1